<template>
  <div class="my-account-wrapper">
    <component :is="currentComponent" />    
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ProfileDetails from './ProfileDetails.vue';
import PixAccountView from './PixAccountView.vue';
import MyEvents from './MyEvents.vue';
import DashboardPage from './Dashboard.vue';
import SettingsPage from './Login.vue'; 
// import RescueRequests from './RescueRequests.vue';
import BottomModal from '@/components/BottomModal.vue'; 
import ProfileEdit from '@/components/ProfileEdit.vue';
import SecurityPrivacy from './SecurityPrivacy.vue';
import EventCreateV2 from './EventCreateV2.vue';

export default {
  components: {
    ProfileDetails,
    PixAccountView,
    MyEvents,
    DashboardPage,
    SettingsPage, 
    // RescueRequests,
    BottomModal,
    ProfileEdit,
    SecurityPrivacy,
    EventCreateV2,
  },
  props: ['page'],
  setup() {
    const route = useRoute();
    const currentComponent = computed(() => {
      const pages = {
        profile: ProfileDetails,
        bank: PixAccountView,
        pix: PixAccountView,
        events: MyEvents,
        dashboard: DashboardPage,
        settings: SettingsPage, 
        // withdrawals: RescueRequests,
        profileEdit: ProfileEdit,
        security: SecurityPrivacy,
        add: EventCreateV2,
        'add-v2': EventCreateV2
      };
      return pages[route.params.page] || DashboardPage;
    });

    return {
      currentComponent,      
    };
  }
};
</script>

<style scoped>
@media (max-width: 767.98px) {
  .my-account-wrapper {
    margin-top: 0rem;
    height: calc(100% + 1rem);
  }
}
</style>